import * as S from './style';
import uuid from 'react-uuid';

interface BoxTabProps {
	menuList: string[];
	menuKey: string;
	isNotSticky?: boolean;
	onListClick: (menu: string) => void;
}

const BoxTab = ({ menuList, menuKey, onListClick, isNotSticky = false }: BoxTabProps) => (
	<>
		<S.TabListContainer isNotSticky={isNotSticky}>
			{menuList.map((menu) => (
				<S.TabListItem key={uuid()} className={menuKey === menu ? 'active' : ''} onClick={() => onListClick(menu)}>
					{menu}
				</S.TabListItem>
			))}
		</S.TabListContainer>
	</>
);

export default BoxTab;
